import { render, staticRenderFns } from "./FeatureFlags.vue?vue&type=template&id=89921aca&scoped=true"
import script from "./FeatureFlags.vue?vue&type=script&lang=ts"
export * from "./FeatureFlags.vue?vue&type=script&lang=ts"
import style0 from "./FeatureFlags.vue?vue&type=style&index=0&id=89921aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89921aca",
  null
  
)

export default component.exports